// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"107":"3aa0bac4","260":"4bb2fa58"}[chunkId] + ".chunk.css";
};